export default __webpack_public_path__ + "static/media/gallery-wip-emitter_03.9eb855eb.jpg";